import { render, staticRenderFns } from "./addItemCodeModal.vue?vue&type=template&id=b4c00878&"
import script from "./addItemCodeModal.vue?vue&type=script&lang=js&"
export * from "./addItemCodeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports